var radioUnicId = 0

// Misma estructura de Sent Payment, sin btn-item-info ni eventos de busqueda.
export function transactions(id) {
  radioUnicId++
  return `
	<div class="line line-${id}" lineId="${id}" id="accountreconciliation_form_mt_${radioUnicId}">
		<div class="row">
			<div class="c33" style="display: flex; width: 41%;">
				<div class="checkbox checkbox-mini selected" style="width: 10%;">
					<input type="checkbox" class="elem" style="top: 7px;"
						data-detail='{"click":[{"dest":"ripple"}]}'>
				</div> <!-- checkbox -->
				<div class="textfield textfield-mini textfield-disabled entity_name">
					<input autocomplete="off" class="elem" type="text" readonly>
				</div> <!-- textfield -->
				<div class="textfield dn transaction_id">
					<input class="elem" type="hidden" readonly>
				</div> <!-- textfield -->
			</div> <!-- c33 -->
			<div class="c14">
				<div class="textfield textfield-mini textfield-disabled account_type">
					<input autocomplete="off" class="elem" type="text" readonly>
				</div> <!-- textfield -->
			</div> <!-- c14 -->
			<div class="c14">
				<div class="textfield textfield-mini textfield-disabled transaction_type">
					<input autocomplete="off" class="elem" type="text" readonly>
				</div> <!-- textfield -->
			</div> <!-- c14 -->
			<div class="c14">
				<div class="textfield textfield-cash textfield-mini textfield-disabled amount">
					<input autocomplete="off" class="elem" type="number" readonly>
				</div> <!-- textfield -->
			</div> <!-- c14 -->
			<div class="c14">
				<div class="textfield textfield-mini textfield-disabled date">
					<input autocomplete="off" class="elem" type="text" readonly>
				</div> <!-- textfield -->
			</div> <!-- c14 -->
		</div> <!-- row -->
	</div> <!-- line -->
  `
}
